import { webApi } from '@lib/api'

export const getProfile = ctx => webApi({ ...ctx, auth: true }).get('/v1/profile')
export const getProfileSubscription = ctx => webApi({ ...ctx, auth: true }).get(`/v1/profile/subscription`)
export const getProfileSubscriptionStatus = ctx => webApi({ ...ctx, auth: true }).get(`/v1/stripe/subscription/current`)
export const updateProfile = data => webApi({ auth: true }).post('/v1/profile', data, { formData: true })
